<template>
  <div class="container">
    <PublicHeader :totalName="$t('share').Transferoutrecord" />
    <!-- 列表 -->
    <div class="listInfo">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText"
        @load="getCommissionChangeLog" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`com${dIndex}`">
          <!-- 佣金转出 -->
          <div class="name">{{ $t('share').Commissiontransferout }} <span class="amount red"
              v-if="dItem.amount < 0">-${{
                -dItem.amount.toFixed(2).replace(/\.?0+$/, '')  }}</span>
            <span class="amount green" v-else>+${{ dItem.amount.toFixed(2).replace(/\.?0+$/, '')  }}</span>
          </div>
          <div class="time">{{ dItem.operTime | getLocalTime }} <span>${{ dItem.after.toFixed(2).replace(/\.?0+$/, '')  }}</span></div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import userApi from '@/api/user'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
        type: '2'
      },
      oList: [],
    }
  },
  mounted() {
    this.getCommissionChangeLog()
  },
  methods: {
    // 获取佣金记录
    async getCommissionChangeLog() {
      if (this.isRun) return
      this.isRun = true
      const res = await userApi.getCommissionChangeLog(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 65px 15px 15px 15px;
  background: var(--background_color);

  .listInfo {

    .item {
      margin-bottom: 30px;

      .name {
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        color: var(--text_color);
      }

      .time {
        margin-top: 10px;
        font-size: 12px;
        color: var(--ntext_color);
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }

}
</style>
